export const formatPhone = (phone) => {
  const number = phone
    .toString()
    .replace(/\D/g, '');

  const pattern = `(\\d{2})(\\d{${number.length > 10 ? 5 : 4}})(\\d)`;
  const regex = new RegExp(pattern, 'gi');
  return number.replace(regex, '($1) $2-$3');
};
